import predicates from '../predicates'
import selectors from '../selectors'
import { SOCIAL_PLATFORMS, SOCIAL_TRAFFIC_SOURCE } from '../constants'

const social = {
  rule: predicates.or(
    predicates.referrerIncludesPlatform(
      SOCIAL_PLATFORMS.FACEBOOK,
      SOCIAL_PLATFORMS.TWITTER,
      SOCIAL_PLATFORMS.INSTAGRAM,
      SOCIAL_PLATFORMS.REDDIT
    ),
    predicates.searchParamEqualsOne('utm_medium', 'fan_page')
  ),
  extractor: traffic => {
    const trafficSource = SOCIAL_TRAFFIC_SOURCE
    const trafficId = selectors.referrerHostname(traffic)

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default social



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/social.js